module.exports = {
	"config": {
		"siteTitle": "Front-end Engineer - Dagobert Renouf, 27",
		"linkPrefix": "/resume"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_CustomLink.js",
				"ext": "js",
				"name": "_CustomLink",
				"extname": ".js",
				"basename": "_CustomLink.js",
				"dirname": "",
				"stem": "_CustomLink",
				"path": "_CustomLink.js"
			},
			"requirePath": "_CustomLink.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_Experience.js",
				"ext": "js",
				"name": "_Experience",
				"extname": ".js",
				"basename": "_Experience.js",
				"dirname": "",
				"stem": "_Experience",
				"path": "_Experience.js"
			},
			"requirePath": "_Experience.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_Modal.js",
				"ext": "js",
				"name": "_Modal",
				"extname": ".js",
				"basename": "_Modal.js",
				"dirname": "",
				"stem": "_Modal",
				"path": "_Modal.js"
			},
			"requirePath": "_Modal.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_Page.js",
				"ext": "js",
				"name": "_Page",
				"extname": ".js",
				"basename": "_Page.js",
				"dirname": "",
				"stem": "_Page",
				"path": "_Page.js"
			},
			"requirePath": "_Page.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_Project.js",
				"ext": "js",
				"name": "_Project",
				"extname": ".js",
				"basename": "_Project.js",
				"dirname": "",
				"stem": "_Project",
				"path": "_Project.js"
			},
			"requirePath": "_Project.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "experiences",
				"base": "christophe-nouvelle-star.json",
				"ext": "json",
				"name": "christophe-nouvelle-star",
				"extname": ".json",
				"basename": "christophe-nouvelle-star.json",
				"dirname": "experiences",
				"stem": "christophe-nouvelle-star",
				"path": "experiences/christophe-nouvelle-star.json"
			},
			"requirePath": "experiences/christophe-nouvelle-star.json",
			"path": "/experiences/christophe-nouvelle-star/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "experiences",
				"base": "dgbrt.json",
				"ext": "json",
				"name": "dgbrt",
				"extname": ".json",
				"basename": "dgbrt.json",
				"dirname": "experiences",
				"stem": "dgbrt",
				"path": "experiences/dgbrt.json"
			},
			"requirePath": "experiences/dgbrt.json",
			"path": "/experiences/dgbrt/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "experiences",
				"base": "french-dezign.json",
				"ext": "json",
				"name": "french-dezign",
				"extname": ".json",
				"basename": "french-dezign.json",
				"dirname": "experiences",
				"stem": "french-dezign",
				"path": "experiences/french-dezign.json"
			},
			"requirePath": "experiences/french-dezign.json",
			"path": "/experiences/french-dezign/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "experiences",
				"base": "model-society.json",
				"ext": "json",
				"name": "model-society",
				"extname": ".json",
				"basename": "model-society.json",
				"dirname": "experiences",
				"stem": "model-society",
				"path": "experiences/model-society.json"
			},
			"requirePath": "experiences/model-society.json",
			"path": "/experiences/model-society/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "euratalent.json",
				"ext": "json",
				"name": "euratalent",
				"extname": ".json",
				"basename": "euratalent.json",
				"dirname": "projects",
				"stem": "euratalent",
				"path": "projects/euratalent.json"
			},
			"requirePath": "projects/euratalent.json",
			"path": "/projects/euratalent/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "lachronique.json",
				"ext": "json",
				"name": "lachronique",
				"extname": ".json",
				"basename": "lachronique.json",
				"dirname": "projects",
				"stem": "lachronique",
				"path": "projects/lachronique.json"
			},
			"requirePath": "projects/lachronique.json",
			"path": "/projects/lachronique/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "websites.json",
				"ext": "json",
				"name": "websites",
				"extname": ".json",
				"basename": "websites.json",
				"dirname": "projects",
				"stem": "websites",
				"path": "projects/websites.json"
			},
			"requirePath": "projects/websites.json",
			"path": "/projects/websites/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0